export const blockIconsActionHighlightOff = (
	<span className='material-symbols-outlined'>highlight_off</span>
);
